<unity-page-container [contentHeader]="$contentHeader()" [contentHeaderSecondary]="$subHeader()" [isLoading]="$resourceLoading()">
  <ng-container notifications />
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementUserListAction()" /></ng-container>
  <ng-container actions>
    <unity-action-delete-shared
      *unityAuthorize="'Agreement:Update'"
      [disabled]="false"
      [buttonText]="`Remove User from Agreement`"
      [confirmationTitle]="`Confirm Remove User from Agreement?`"
      [confirmationMessage]="`Are you sure you want to remove this user from agreement?`"
      (deleteEvent)="onDelete()" />
  </ng-container>

  @let user = $resource();
  <unity-panel-manage-shared
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="$formGroup()"
    [isEditable]="false"
    [submitLoading]="$updateLoading()"
    (saveEvent)="onSave()"
    (detailEditEvent)="toggleWorkflowActions($event)">
    <unity-form-layout>
      <unity-textbox-readonly-control displayName="Name" [value]="user?.full_name ?? ''" />
      <unity-textbox-readonly-control displayName="Email" [value]="user?.user_name ?? ''" />
      <unity-textbox-readonly-control displayName="Role" [value]="user?.user_role_name ?? ''" />
    </unity-form-layout>
  </unity-panel-manage-shared>
</unity-page-container>
